import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PvListProcessingService {

  isPvListProcessingisRunning(): boolean {
    let isPvListProcessingisRunning: boolean = false;

    const isPvListProcessingisRunningStr: string = localStorage.getItem("isPvListProcessingisRunning");
    if (isNotNullOrUndefined(isPvListProcessingisRunning)) {
      if (isPvListProcessingisRunningStr === "true") {
        isPvListProcessingisRunning = true;
      }
    }

    return isPvListProcessingisRunning;
  }


  setPvListProcessingisRunning(isRunning: boolean) {
    localStorage.setItem("isPvListProcessingisRunning", "" + isRunning);
  }

  constructor(
    private http: HttpClient) {
   }

  getPvListTemplate(): Observable<any>{
    return this.http.get(environment.API_BASE_URL + "gui/getPvListTemplate", { responseType: 'blob' });
  }
}

